import { render, staticRenderFns } from "./Transfer_goods_edit.vue?vue&type=template&id=3c120154&scoped=true&"
import script from "./Transfer_goods_edit.vue?vue&type=script&lang=js&"
export * from "./Transfer_goods_edit.vue?vue&type=script&lang=js&"
import style0 from "./Transfer_goods_edit.vue?vue&type=style&index=0&id=3c120154&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c120154",
  null
  
)

export default component.exports